import {
  NEXT_PAGE,
  PREVIOUS_PAGE,
  SET_CARD_APPLICATION_ID,
  SET_CURRENT_PAGE,
  SET_SIGNUP_COMPLETE,
  SET_SIGNUP_NEW_CUSTOMER,
  SET_WIDGET_FINISHED,
  SET_WIDGET_LOADING,
  SET_WIDGET_INITIATED,
  SET_IS_COMPANY_VALID,
  SET_IS_ADDITIONAL_HOUSE_NUMBER_REQUIRED,
  SET_ACCESS_TOKEN,
  SET_CLIENT_ID,
} from '~/actions/actionTypes';

const INITIAL_STATE: any = {};

const widgetContextReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case NEXT_PAGE:
    case PREVIOUS_PAGE:
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_SIGNUP_NEW_CUSTOMER:
      return {
        ...state,
        signupNewCustomer: action.payload,
      };
    case SET_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.payload,
      };
    case SET_CLIENT_ID:
      return {
        ...state,
        clientId: action.payload,
      };
    case SET_SIGNUP_COMPLETE:
      return {
        ...state,
        signupCompleted: action.payload,
      };
    case SET_IS_COMPANY_VALID:
      return {
        ...state,
        isCompanyValid: action.payload,
      };
    case SET_IS_ADDITIONAL_HOUSE_NUMBER_REQUIRED:
      return {
        ...state,
        isAdditionalHouseNumberRequired: action.payload,
      };
    case SET_CARD_APPLICATION_ID:
      return {
        ...state,
        cardApplicationId: action.payload,
      };
    case SET_WIDGET_FINISHED:
      return {
        ...state,
        widgetFinished: action.payload,
      };
    case SET_WIDGET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_WIDGET_INITIATED:
      return {
        ...state,
        isInitiated: action.payload,
      };
    default:
      return state;
  }
};

export default widgetContextReducer;
